/**
 * Click event implementation
 * @module
 */
var Analytics = require('core/analytics');
var ClickDelegate = require('./click_delegate');
var Logger = require('core/utils/logger');
var View = require('core/view');

module.exports = function(PluginManager) {
  var clickDelegate = new ClickDelegate(
    /**
     * Handler function triggered whenever a click matches a specific userEvent
     * @param {Event} userEvent
     */
    function(userEvent) {
      // Re-evaluate view tags after every event
      View.updateAllViewTags();

      var clickEvent = Analytics.trackClickEvent(userEvent);
      if (clickEvent) {
        Logger.log('Tracking click event:', userEvent);
      } else {
        Logger.log('Not tracking click event:', userEvent);
      }
    }
  );

  PluginManager.registerEventImplementation('click', {
    attach: function(event) {
      if (!clickDelegate.hasEvents()) {
        clickDelegate.listen();
      }

      clickDelegate.addEvent(event);

      Logger.debug('Started listening for click event (' + formatEventToStr(event) + '):', event);
    },

    detach: function(event) {
      clickDelegate.removeEvent(event);

      if (!clickDelegate.hasEvents()) {
        clickDelegate.unlisten();
      }

      Logger.debug('Stopped listening for click event (' + formatEventToStr(event) + '):', event);
    },
  });
};

function formatEventToStr(event) {
  return 'apiName: ' + event.apiName + ', selector: ' + event.eventFilter.selector;
}
